import { render, staticRenderFns } from "./detailOperationRecord.vue?vue&type=template&id=bba8a4ac&scoped=true&"
import script from "./detailOperationRecord.vue?vue&type=script&lang=js&"
export * from "./detailOperationRecord.vue?vue&type=script&lang=js&"
import style0 from "./detailOperationRecord.vue?vue&type=style&index=0&id=bba8a4ac&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba8a4ac",
  null
  
)

export default component.exports